module.exports = __webpack_public_path__ + "static/media/outlook.616a6b48.svg";